export type Maybe<T> = T | null
export type If<T, V> = { __typename: T } & V
export type Operation<Data, Variables = undefined> = {
  query: string
  variables: Variables
}
export type ById<T> = { [id: string]: T | undefined }

export enum Currency {
  SOC = 'SOC',
  USD = 'USD',
  UNAVAILABLE = 'UNAVAILABLE',
}

export enum CardType {
  POSTCARD = 'POSTCARD',
  FLATCARD = 'FLATCARD',
  TWO_PANEL = 'TWO_PANEL',
  THREE_PANEL = 'THREE_PANEL',
  TWO_PANEL_BIG = 'TWO_PANEL_BIG',
}

export enum CardPaperType {
  STD = 'STD',
  PRE = 'PRE',
  HVY = 'HVY',
}

export enum ContactRequestStatusEnum {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
}

export enum CardSendType {
  HEARTFELT = 'HEARTFELT',
  SYSTEM = 'SYSTEM',
}

export enum CurrencyType {
  POINT = 'POINT',
  EXPENSE = 'EXPENSE',
  FREE = 'FREE',
  USD = 'USD',
  CREDIT = 'CREDIT',
  CARDTOKEN = 'CARDTOKEN',
}

export enum LayoutCategory {
  BASIC_LAYOUTS = 'BASIC_LAYOUTS',
  BACK_PANELS = 'BACK_PANELS',
}

export enum Owner {
  USER = 'USER',
  SYSTEM = 'SYSTEM',
}

export enum LayoutDimensions {
  VERTICAL = 'VERTICAL',
  HORIZONTAL = 'HORIZONTAL',
  POSTCARD = 'POSTCARD',
}

export enum ReminderType {
  ANNIVERSARY = 'ANNIVERSARY',
  BIRTHDAY = 'BIRTHDAY',
  PROJECT = 'PROJECT',
}

export enum NewReminderType {
  ANNIVERSARY = 'ANNIVERSARY',
  BIRTHDAY = 'BIRTHDAY',
  CAMPAIGN = 'CAMPAIGN',
}

export enum NotificationType {
  ANNIVERSARY = 'ANNIVERSARY',
  BIRTHDAY = 'BIRTHDAY',
  CAMPAIGN = 'CAMPAIGN',
  REJECTED_CARDS = 'REJECTED_CARDS',
  HELD_PRODUCTION_INFOS = 'HELD_PRODUCTION_INFOS',
  CONTACT_REQUEST_COMPLETED = 'CONTACT_REQUEST_COMPLETED',
  ACT_PRINT_REQUESTED = 'ACT_PRINT_REQUESTED',
}

export enum TextAlignment {
  LEFT = 'LEFT',
  CENTER = 'CENTER',
  RIGHT = 'RIGHT',
}

export enum SendDelayType {
  IMM = 'IMM',
  BIR = 'BIR',
  ANN = 'ANN',
  SPE = 'SPE',
}

export enum SendDelayDelayType {
  DAY = 'DAY',
  WEE = 'WEE',
  MON = 'MON',
}

export enum SendDelayTimeType {
  BEF = 'BEF',
  AFT = 'AFT',
}

export enum VerifyPhoneNumberFailureType {
  CODE_EXPIRED = 'CODE_EXPIRED',
  INCORRECT_CODE = 'INCORRECT_CODE',
  ALREADY_VERIFIED = 'ALREADY_VERIFIED',
  TOO_MANY_ATTEMPTS = 'TOO_MANY_ATTEMPTS',
  UNVERIFIED_ACCOUNT_FOUND = 'UNVERIFIED_ACCOUNT_FOUND',
  NO_VERIFIED_ACCOUNTS_FOUND = 'NO_VERIFIED_ACCOUNTS_FOUND',
  DIGITAL_GIFT_CARD_ALREADY_REDEEMED_DIFFERENT_NUMBER = 'DIGITAL_GIFT_CARD_ALREADY_REDEEMED_DIFFERENT_NUMBER',
  DIGITAL_GIFT_CARD_NOT_FOUND = 'DIGITAL_GIFT_CARD_NOT_FOUND',
}

export enum MarketingPricingGridRowItemIconChoices {
  A_10_CARD = 'A_10_CARD',
  A_15_CARD = 'A_15_CARD',
  A_20_CARD = 'A_20_CARD',
  A_25_CARD = 'A_25_CARD',
  BROCHURE = 'BROCHURE',
  CANCEL = 'CANCEL',
  CARD = 'CARD',
  CARD_ERROR = 'CARD_ERROR',
  CHECK = 'CHECK',
  CONTACT = 'CONTACT',
  DANGER = 'DANGER',
  DATABASE = 'DATABASE',
  DOUBLE_CHECK = 'DOUBLE_CHECK',
  EDIT = 'EDIT',
  EMPTY_GIFT = 'EMPTY_GIFT',
  GIFT = 'GIFT',
  HEARTFELT = 'HEARTFELT',
  INFO = 'INFO',
  MULTIPLE_CARDS = 'MULTIPLE_CARDS',
  PACKAGE = 'PACKAGE',
  PAPER_PLANE = 'PAPER_PLANE',
  PAPER_PLANE_FLYING = 'PAPER_PLANE_FLYING',
  PAPER_PLANE_WITH_HEART = 'PAPER_PLANE_WITH_HEART',
  REPLACE = 'REPLACE',
  SEARCH = 'SEARCH',
  SHOPPING_CART = 'SHOPPING_CART',
  UPLOAD = 'UPLOAD',
  USER = 'USER',
  V_CHECK = 'V_CHECK',
  X = 'X',
  SMILE_CARD = 'SMILE_CARD',
  SMILE_CARD_W_HEARTS = 'SMILE_CARD_W_HEARTS',
  SMILE_CARD_W_HEART = 'SMILE_CARD_W_HEART',
  SOLOPRENEUR = 'SOLOPRENEUR',
  ENTREPRENEUR = 'ENTREPRENEUR',
  BUSINESSPRENEUR = 'BUSINESSPRENEUR',
  CARD_PACK = 'CARD_PACK',
  TIME_BLOCK = 'TIME_BLOCK',
  EXP_CALENDAR = 'EXP_CALENDAR',
  CHECK_MARK = 'CHECK_MARK',
  TICKET = 'TICKET',
  AUTOMATED_CARD = 'AUTOMATED_CARD',
  CAMPAIGN_CARD = 'CAMPAIGN_CARD',
  GROUP_SEND_CARD = 'GROUP_SEND_CARD',
  SCHEDULE_CARD = 'SCHEDULE_CARD',
  MULTI_TOUCH_CARD = 'MULTI_TOUCH_CARD',
  CATALOG_CARD = 'CATALOG_CARD',
  PHOTO_DROP_CARD = 'PHOTO_DROP_CARD',
  ENHANCED_STORAGE = 'ENHANCED_STORAGE',
  PREMIUM_STORAGE = 'PREMIUM_STORAGE',
  PERSONAL_SIGNATURE = 'PERSONAL_SIGNATURE',
  PERSONAL_HAND_WRITING = 'PERSONAL_HAND_WRITING',
  ESSENTIAL_PACKS = 'ESSENTIAL_PACKS',
}

export type NormalizedContact = {
  lastName?: string
  notes?: {
    __typename: 'Note'
    id: string
  }[]
  __typename: 'Contact'
  faxNumber?: Maybe<string>
  parent?: Maybe<{
    lastName: string
    faxNumber: Maybe<string>
    city: string
    cellPhone: Maybe<string>
    homePhone: Maybe<string>
    anniversary: Maybe<{
      __typename: 'OptionalYearDate'
      day: number
      month: number
      year: Maybe<number>
    }>
    state: string
    country: Maybe<string>
    emailAddress: Maybe<string>
    postalCode: string
    isPrimary: boolean
    website: string
    id: string
    firstName: string
    company: string
    workPhone: Maybe<string>
    birthday: Maybe<{
      __typename: 'OptionalYearDate'
      day: number
      month: number
      year: Maybe<number>
    }>
    address1: string
    address2: string
  }>
  city?: string
  cellPhone?: Maybe<string>
  contactRequest?: Maybe<{
    id: string
    status: ContactRequestStatusEnum
    token: string
    expiresAt: string
  }>
  homePhone?: Maybe<string>
  anniversary?: Maybe<{
    __typename: 'OptionalYearDate'
    day: number
    month: number
    year: Maybe<number>
  }>
  state?: string
  groups?: {
    __typename: 'Group'
    id: string
  }[]
  spouse?: Maybe<{
    lastName: string
    faxNumber: Maybe<string>
    city: string
    cellPhone: Maybe<string>
    homePhone: Maybe<string>
    anniversary: Maybe<{
      __typename: 'OptionalYearDate'
      day: number
      month: number
      year: Maybe<number>
    }>
    state: string
    country: Maybe<string>
    emailAddress: Maybe<string>
    postalCode: string
    isPrimary: boolean
    website: string
    id: string
    firstName: string
    company: string
    workPhone: Maybe<string>
    birthday: Maybe<{
      __typename: 'OptionalYearDate'
      day: number
      month: number
      year: Maybe<number>
    }>
    address1: string
    address2: string
  }>
  country?: Maybe<string>
  emailAddress?: Maybe<string>
  postalCode?: string
  isPrimary?: boolean
  website?: string
  id: string
  firstName?: string
  company?: string
  workPhone?: Maybe<string>
  birthday?: Maybe<{
    __typename: 'OptionalYearDate'
    day: number
    month: number
    year: Maybe<number>
  }>
  address1?: string
  address2?: string
  children?: {
    lastName: string
    faxNumber: Maybe<string>
    city: string
    cellPhone: Maybe<string>
    homePhone: Maybe<string>
    anniversary: Maybe<{
      __typename: 'OptionalYearDate'
      day: number
      month: number
      year: Maybe<number>
    }>
    state: string
    country: Maybe<string>
    emailAddress: Maybe<string>
    postalCode: string
    isPrimary: boolean
    website: string
    id: string
    firstName: string
    company: string
    workPhone: Maybe<string>
    birthday: Maybe<{
      __typename: 'OptionalYearDate'
      day: number
      month: number
      year: Maybe<number>
    }>
    address1: string
    address2: string
  }[]
}

export type NormalizedGiftVariation = {
  points?: {
    __typename: 'Amount'
    amount: number
    currency: Currency
    description: string
  }
  packaging?: Maybe<string>
  __typename: 'GiftVariation'
  price?: {
    __typename: 'Price'
    asString: string
    currency: CurrencyType
    amount: number
  }
  name?: string
  isSendable?: boolean
  shipping?: Maybe<string>
  defaultImageUrl?: string
  contents?: Maybe<string>
  id: string
  description?: Maybe<string>
  isEligibleFreeGift?: boolean
  imageUrls: string[]
}

export type NormalizedMarketingParagraph = {
  __typename: 'MarketingParagraph'
  createdAt: string
  updatedAt: string
  id: string
  title: string
  content: string
}

export type NormalizedNotification = {
  __typename: 'Notification'
  message: Maybe<string>
  linkText: Maybe<string>
  data: Maybe<string>
  acceptText: Maybe<string>
  denyText: Maybe<string>
  type: Maybe<NotificationType>
  link: Maybe<string>
  id: string
  createdAt: string
}

export type NormalizedUser = {
  lastName: string
  __typename: 'User'
  promptingsCoach?: Maybe<{
    isEmailPublic: boolean
    isPhoneNumberPublic: boolean
  }>
  shippingAddress?: Maybe<{
    city: string
    state: string
    country: string
  }>
  storefront?: Maybe<{
    __typename: 'Storefront'
    mugshot: Maybe<{
      url: string
    }>
    biography: Maybe<string>
    slug: Maybe<string>
  }>
  username?: string
  dateJoined?: string
  id: string
  firstName: string
  formattedPhoneNumber?: string
  genealogyId?: number
  email: string
}

export type NormalizedRecipientLine = {
  __typename: 'RecipientLine'
  id: string
}

export type NormalizedCardCategory = {
  __typename: 'CardCategory'
  id: string
  description: string
  cards: {
    __typename: 'SendableCard'
    id: string
  }[]
  thumbnail: string
}

export type NormalizedGiftCategory = {
  __typename: 'GiftCategory'
  id: string
  name: string
  children: {
    id: string
    name: string
    children: {
      id: string
      name: string
      children: {
        id: string
        name: string
      }[]
    }[]
  }[]
}

export type NormalizedOrder = {
  sendType?: CardSendType
  isSent?: boolean
  returnAddress?: Maybe<{
    lastName: string
    __typename: 'Address'
    city: string
    state: string
    country: string
    postalCode: string
    firstName: string
    company: string
    address1: string
    address2: string
  }>
  __typename: 'Order'
  invalidContacts?: {
    __typename: 'Contact'
    id: string
  }[]
  isSendable?: boolean
  cost?: {
    total: {
      __typename: 'Price'
      asString: string
      currency: CurrencyType
      amount: number
    }[]
    entries: {
      __typename: 'LabeledPrice'
      label: string
      asString: string
      currency: CurrencyType
      amount: number
    }[]
  }
  updatedAt?: string
  campaign?: Maybe<{
    __typename: 'Campaign'
    id: string
  }>
  contacts?: {
    __typename: 'Contact'
    id: string
  }[]
  groups?: {
    __typename: 'Group'
    id: string
  }[]
  warnings?: {
    __typename: 'Error'
    code: Maybe<number>
    message: Maybe<string>
  }[]
  invalidSendDelayContacts?: {
    __typename: 'Contact'
    id: string
  }[]
  id: string
  createdAt?: string
  bulkUpgradeShippingAddress?: Maybe<{
    lastName: string
    __typename: 'Address'
    city: string
    state: string
    country: string
    postalCode: string
    firstName: string
    company: string
    address1: string
    address2: string
  }>
  isBulk?: boolean
  bulkUpgradeCardQty?: Maybe<number>
  minimalLines?: {
    __typename: 'Line'
    card: Maybe<{
      __typename: 'Card'
      id: string
    }>
    giftVariation: Maybe<{
      __typename: 'GiftVariation'
      id: string
    }>
  }[]
  lines?: {
    __typename: 'Line'
    card: Maybe<{
      __typename: 'Card'
      id: string
    }>
    giftVariation: Maybe<{
      __typename: 'GiftVariation'
      id: string
    }>
    sendDelay: {
      __typename: 'SendDelay'
      type: SendDelayType
      delayNumber: Maybe<number>
      delayType: SendDelayDelayType
      timeType: SendDelayTimeType
      specificDate: string
    }
    cost: {
      total: {
        __typename: 'Price'
        asString: string
        currency: CurrencyType
        amount: number
      }[]
      entries: {
        __typename: 'LabeledPrice'
        label: string
        asString: string
        currency: CurrencyType
        amount: number
      }[]
    }
    baseCost: {
      total: {
        __typename: 'Price'
        asString: string
        currency: CurrencyType
        amount: number
      }[]
      entries: {
        __typename: 'LabeledPrice'
        label: string
        asString: string
        currency: CurrencyType
        amount: number
      }[]
    }
    recipientCount: number
  }[]
}

export type NormalizedFont = {
  __typename: 'Font'
  id: string
  fontName: string
}

export type NormalizedCampaignShare = {
  __typename: 'CampaignShare'
  id: string
  fromName: string
  dateShared: string
  campaign: {
    __typename: 'Campaign'
    id: string
  }
}

export type NormalizedCampaign = {
  __typename: 'Campaign'
  id: string
  name: string
  isShareable?: boolean
  lines?: {
    __typename: 'CampaignLine'
    name: Maybe<string>
    card: Maybe<{
      __typename: 'Card'
      id: string
    }>
    giftVariation: Maybe<{
      __typename: 'GiftVariation'
      id: string
    }>
    sendDelay: {
      __typename: 'SendDelay'
      type: SendDelayType
      delayNumber: Maybe<number>
      delayType: SendDelayDelayType
      timeType: SendDelayTimeType
      specificDate: string
    }
  }[]
}

export type NormalizedGift = {
  id: string
  realId: string
  __typename: 'Gift'
  name: string
  defaultImageUrl: string
  defaultVariation: Maybe<{
    __typename: 'GiftVariation'
    id: string
  }>
  variations?: {
    __typename: 'GiftVariation'
    id: string
  }[]
}

export type NormalizedCard = {
  detailedSendableCard?: Maybe<{
    __typename: 'SendableCard'
    id: string
  }>
  insidePreviewUrl?: Maybe<string>
  __typename: 'Card'
  paperType?: CardPaperType
  cost?: {
    total: {
      __typename: 'Price'
      asString: string
      currency: CurrencyType
      amount: number
    }[]
    entries: {
      __typename: 'LabeledPrice'
      label: string
      asString: string
      currency: CurrencyType
      amount: number
    }[]
  }
  backPreviewUrl?: string
  isHorizontal?: boolean
  panels?: {
    isFullBleed: boolean
    __typename: 'Panel'
    width: number
    previewUrl: string
    height: number
    name: string
    isLocked: boolean
    backgroundColor: Maybe<{
      __typename: 'Color'
      red: number
      green: number
      blue: number
    }>
    location: number
    elements: {
      __typename: 'Element'
      width: number
      height: number
      locked: boolean
      text: Maybe<{
        paragraphs: {
          __typename: 'Paragraph'
          textFragments: {
            __typename: 'TextFragment'
            text: string
            textColor: {
              __typename: 'Color'
              red: number
              green: number
              blue: number
            }
            font: {
              __typename: 'Font'
              id: string
            }
            fontSize: number
            isReplacement: boolean
          }[]
          alignment: TextAlignment
        }[]
      }>
      draggable: Maybe<boolean>
      x: number
      y: number
      z: number
      image: Maybe<{
        __typename: 'ElementPicture'
        image: Maybe<{
          __typename: 'Image'
          id: string
        }>
        position: {
          x: number
          y: number
        }
        scale: number
        filter: Maybe<{
          name: string
        }>
      }>
      rotation: number
    }[]
  }[]
  frontPreviewUrl?: string
  minimalPanels?: {
    __typename: 'Panel'
    name: string
    previewUrl: string
    isFullBleed: boolean
    width: number
    height: number
  }[]
  backPanelLocation?: number
  sendableCard?: Maybe<{
    __typename: 'SendableCard'
    id: string
  }>
  isNewEditorCard?: boolean
  paperUpgradeCosts?: {
    value: string
    upgrade: string
  }[]
  showInPicturePlus?: boolean
  tinyThumb?: string
  type?: CardType
  id: string
  flapPreviewUrl?: Maybe<string>
}

export type NormalizedItemCategory = {
  children?: {
    __typename: 'ItemCategory'
    id: string
  }[]
  __typename: 'ItemCategory'
  id: string
  name: string
  backgroundImageUrl: Maybe<string>
  items: {
    __typename: 'Item'
    id: string
  }[]
}

export type NormalizedNote = {
  __typename: 'Note'
  id: string
  text: string
  date: Maybe<{
    __typename: 'CalendarDate'
    day: number
    month: number
    year: number
  }>
}

export type NormalizedSendableCard = {
  variations?: {
    __typename: 'SendableCard'
    id: string
  }[]
  __typename: 'SendableCard'
  isFavorite?: boolean
  cardTemplate?: Maybe<{
    __typename: 'Card'
    id: string
  }>
  cost?: {
    total: {
      __typename: 'Price'
      asString: string
      currency: CurrencyType
      amount: number
    }[]
    entries: {
      __typename: 'LabeledPrice'
      label: string
      asString: string
      currency: CurrencyType
      amount: number
    }[]
  }
  isHorizontal?: boolean
  variationColor?: string
  frontImage?: {
    __typename: 'Image'
    id: string
  }
  isPaidDesign?: boolean
  isPhotoDrop?: boolean
  title: string
  id: string
  insideRightImage?: Maybe<{
    __typename: 'Image'
    id: string
  }>
  description?: string
}

export type NormalizedPlansDescription = {
  __typename: 'PlansDescription'
  id: string
  description: string
}

export type NormalizedItem = {
  __typename: 'Item'
  id: string
  description: Maybe<string>
  itemCode: string
  price: number
  name: Maybe<string>
  image: Maybe<string>
  campaign: Maybe<{
    __typename: 'Campaign'
    id: string
  }>
}

export type NormalizedRecipient = {
  contact: Maybe<{
    __typename: 'Contact'
    id: string
  }>
  paymentFailure: Maybe<{
    id: string
  }>
  __typename: 'Recipient'
  recipientLine: Maybe<{
    __typename: 'RecipientLine'
    id: string
  }>
  gift: Maybe<{
    name: string
    defaultImageUrl: string
  }>
  card: Maybe<{
    __typename: 'Card'
    id: string
  }>
  address: Maybe<{
    lastName: string
    __typename: 'Address'
    city: string
    state: string
    userVerified: boolean
    errorMessages: string[]
    country: string
    postalCode: string
    firstName: string
    company: string
    address1: string
    address2: string
  }>
  id: string
  cardQuantity: number
}

export type NormalizedImage = {
  __typename: 'Image'
  id: string
  url: string
  smallThumb: string
  width: number
  height: number
  mediumThumb?: string
}

export type NormalizedMarketingMultiParagraph = {
  __typename: 'MarketingMultiParagraph'
  createdAt: string
  updatedAt: string
  id: string
  title: string
  content: string
}

export type NormalizedCollection = {
  backgroundImageUrl: Maybe<string>
  cards: {
    __typename: 'SendableCard'
    id: string
  }[]
  __typename: 'Collection'
  reasonToSend: boolean
  backgroundStartColor: string
  textColor: string
  backgroundEndColor: string
  title: string
  id: string
  description: string
}

export type NormalizedGroup = {
  __typename: 'Group'
  id: string
  name: string
  members?: {
    __typename: 'Contact'
    id: string
  }[]
  description?: string
}

export type NormalizedContactShare = {
  __typename: 'ContactShare'
  id: string
  contact: {
    __typename: 'Contact'
    id: string
  }
  fromUser: {
    __typename: 'User'
    id: string
  }
  createdAt: string
}

export type NormalizedData = {
  Contact: ById<NormalizedContact>
  GiftVariation: ById<NormalizedGiftVariation>
  MarketingParagraph: ById<NormalizedMarketingParagraph>
  Notification: ById<NormalizedNotification>
  User: ById<NormalizedUser>
  RecipientLine: ById<NormalizedRecipientLine>
  CardCategory: ById<NormalizedCardCategory>
  GiftCategory: ById<NormalizedGiftCategory>
  Order: ById<NormalizedOrder>
  Font: ById<NormalizedFont>
  CampaignShare: ById<NormalizedCampaignShare>
  Campaign: ById<NormalizedCampaign>
  Gift: ById<NormalizedGift>
  Card: ById<NormalizedCard>
  ItemCategory: ById<NormalizedItemCategory>
  Note: ById<NormalizedNote>
  SendableCard: ById<NormalizedSendableCard>
  PlansDescription: ById<NormalizedPlansDescription>
  Item: ById<NormalizedItem>
  Recipient: ById<NormalizedRecipient>
  Image: ById<NormalizedImage>
  MarketingMultiParagraph: ById<NormalizedMarketingMultiParagraph>
  Collection: ById<NormalizedCollection>
  Group: ById<NormalizedGroup>
  ContactShare: ById<NormalizedContactShare>
}

export const NormalizedData = (): NormalizedData => ({
  Contact: {},
  GiftVariation: {},
  MarketingParagraph: {},
  Notification: {},
  User: {},
  RecipientLine: {},
  CardCategory: {},
  GiftCategory: {},
  Order: {},
  Font: {},
  CampaignShare: {},
  Campaign: {},
  Gift: {},
  Card: {},
  ItemCategory: {},
  Note: {},
  SendableCard: {},
  PlansDescription: {},
  Item: {},
  Recipient: {},
  Image: {},
  MarketingMultiParagraph: {},
  Collection: {},
  Group: {},
  ContactShare: {},
})
